// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.KeyJoinComparisonValue.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/fp';
import Select from 'share/components/controls/multiSelectBox/Izenda.Select';
import Validator from 'share/components/hoc/Izenda.Validator';
import { REGEX, ERROR_MESSAGE_BY_DATA_TYPE } from 'logic/data/Izenda.FilterDetailsConfigConstants';
import { DATA_TYPES } from 'logic/data/Izenda.ReportDesignerConstants';
import connect from 'share/enhancers/Izenda.Connect';
import Input from 'share/components/controls/Izenda.Input';
import NumericInput from 'share/components/controls/Izenda.NumericInput';

const ValidatorSelect = Validator()(Select);

@connect()
export default class KeyJoinComparisonValue extends Component {
  static propTypes = {
    joinField: PropTypes.object.isRequired,
    changeComparisionValue: PropTypes.func.isRequired,
    value: PropTypes.string,
    multi: PropTypes.bool,
    group: PropTypes.string,
    field: PropTypes.string
  };

  static defaultProps = {
    multi: false
  };

  componentWillReceiveProps(nextProps: any) {
    // Clear value when change from multi -> single
    this.props.multi &&
      !nextProps.multi &&
      this.props.changeComparisionValue &&
      this.props.changeComparisionValue(null);
  }

  /**
   * Add new value to multi select
   * @param {object} value
   */
  addComparisionValue = (value: Object) => {
    const { joinField, group, field, validation: valManager } = this.props;
    if (this.isNumericInput()) {
      const isValid = String.isPatternFormat(value.value, REGEX.NUMBER);
      const errorMessage = ERROR_MESSAGE_BY_DATA_TYPE[joinField.izendaDataType];

      if (!isValid) {
        valManager.updateErrors([{ key: `${group}${field}`, messages: errorMessage }]);
        return false;
      }
    }

    return true;
  };

  /**
   * Render multi select component
   */
  renderMultiSelectComponent() {
    const { value, multi, changeComparisionValue, group, field } = this.props;
    const options = value ? value.split(';#').map(item => ({ label: item, value: item })) : [];

    return (
      <ValidatorSelect
        controlClass='fitContent'
        value={value}
        group={group}
        field={field}
        multi={multi}
        simpleValue
        delimiter=';#'
        options={options}
        onChange={changeComparisionValue}
        onAddNew={this.addComparisionValue}
        scalable={false}
        hiddenMenu
        textboxMode
        inputMaxHeight={90}
        placeholder=''
      />
    );
  }

  /**
   * Is render numeric input
   */
  isNumericInput() {
    const { joinField } = this.props;
    return joinField && [DATA_TYPES.NUMERIC, DATA_TYPES.MONEY].indexOf(joinField.izendaDataType) > -1;
  }

  /**
   * On change single input
   * @param {any} value
   */
  onChangeSingleInput = (value: any) => {
    const changedValue = this.isNumericInput() ? value : value.target.value;
    this.props.changeComparisionValue && this.props.changeComparisionValue(changedValue);
  };

  /**
   * Render single select component
   */
  renderSingleSelectComponent() {
    const { value, group, field } = this.props;
    const InputComponent = this.isNumericInput() ? NumericInput : Input;
    return (
      <InputComponent
        value={value}
        group={group}
        field={field}
        onChange={this.onChangeSingleInput}
      />
    );
  }

  render() {
    const { multi } = this.props;
    return multi ? this.renderMultiSelectComponent() : this.renderSingleSelectComponent();
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSource/Izenda.KeyJoinComparisonValue.js